import { isOfferPriceUnavailable } from '@/lib/products/display-offer-selection'

/** Public price/freshness fields accepted by the shared buy-box selector. */
export interface ProductBuyBoxCandidate {
  id: string
  priceCents: number
  isPriceUnknown: false
}

/**
 * FRIDGE-117: map the server offer shape explicitly and preserve the lowest
 * genuine price. Commercial rates are not selection inputs under the current
 * owner direction; their presence cannot promote a more expensive offer.
 */
export function buildProductBuyBoxCandidates(
  offers: readonly { id: string; price: number | null; priceStale?: boolean }[],
): ProductBuyBoxCandidate[] {
  return offers
    // FRIDGE-1643: the page's one "Price Unavailable" rule.
    .filter((offer): offer is typeof offer & { price: number } => !isOfferPriceUnavailable(offer))
    .map(offer => ({ id: offer.id, priceCents: offer.price, isPriceUnknown: false as const }))
    .sort((a, b) => a.priceCents - b.priceCents || a.id.localeCompare(b.id))
}

/** A cached server choice must still match a current lowest fresh price. */
export function canUseServerBuyBox(
  server: { priceCents?: number | null; isPriceUnknown?: boolean } | null | undefined,
  lowest: { priceCents?: number | null; isPriceUnknown?: boolean } | null | undefined,
): boolean {
  return !!server && !!lowest && server.isPriceUnknown !== true && lowest.isPriceUnknown !== true &&
    typeof server.priceCents === 'number' && Number.isFinite(server.priceCents) && server.priceCents > 0 &&
    server.priceCents === lowest.priceCents
}
